DocumentModalValidator.$inject = ['validator'];

export default function DocumentModalValidator(validator) {
	const instance = new validator();
	instance.ruleFor('code').notEmpty().when(isNotCodeAuto).withMessage('VALIDATION_NOTEMPTY');
	instance.ruleFor('code').length(1, 15).when(isNotCodeAuto).withMessage('VALIDATION_TOO_LONG_15');
	instance
		.ruleFor('code')
		.matches(/^[a-zA-Z0-9_|]*$/)
		.withMessage('CODE_CHARACTERS_NOK');
	instance.ruleFor('libelle').notEmpty().withMessage('VALIDATION_NOTEMPTY');
	instance.ruleFor('extension').must(BeAValidExtension).withMessage('VALIDATION_FORMAT_INCORRECT');
	instance.ruleFor('idType').notEmpty().withMessage('VALIDATION_NOEMPTY');
	instance.ruleFor('codeExists').notEqual(true).withMessage('VALIDATION_NOTEMPTY');

	function isNotCodeAuto(obj) {
		return !obj.estCodeAuto;
	}
	function BeAValidExtension(file) {
		const extArray = [
			'pdf',
			'docx',
			'doc',
			'docm',
			'xlsx',
			'xls',
			'pptx',
			'ppt',
			'jpg',
			'png',
			'bmp',
			'gif',
			'txt',
			'zip',
			'rar',
			'PDF',
			'DOCX',
			'DOC',
			'DOCM',
			'XLSX',
			'XLS',
			'PPTX',
			'PPT',
			'JPG',
			'PNG',
			'BMP',
			'GIF',
			'TXT',
			'ZIP',
			'RAR'
		];
		if (extArray.includes(file.extension)) {
			return true;
		}
		return false;
	}

	return instance;
}
